import { secureGet, securePost } from "config/encryption_decryption/get_post_encryptDecrypt";

export const verifyUser = async (cred) => {
  const { email } = cred;
  return securePost("/api/survey/check_join_now_Email", { email });
};

export const registerUser = async (cred) => {
  const {
    password,
    firstName,
    lastName,
    email,
    dateOfBirth,
    gender,
    referalId,
    active,
    language,
    timeZone,
    currentUrl,
    sid,
    socialID,
    country,
    state,
    geo,
    clickid,
    ipAddress,
  } = cred;
  return securePost("/api/survey/join_now", {
    password,
    firstName,
    lastName,
    email,
    dateOfBirth,
    gender,
    referalId,
    active,
    language,
    timeZone,
    currentUrl,
    sid,
    socialID,
    country,
    state,
    geo,
    clickid,
    ipAddress,
  });
};

export const registerUserNew = async (data) => {
  return securePost("/api/survey/join_now", { data });
};

export const registerUserWithGoogle = async (cred) => {
  const {
    password,
    firstName,
    lastName,
    email,
    dateOfBirth,
    gender,
    referalId,
    active,
    language,
    timeZone,
    currentUrl,
    sid,
    socialID,
    country,
    state,
    geo,
    clickid,
    ipAddress,
    sessionId,
    uid,
    isGuest,
    altcha,
    marketingConsent,
    isSubscribed,
    credential,
  } = cred;
  return securePost("/api/survey/joinNow_with_google", {
    password,
    firstName,
    lastName,
    email,
    dateOfBirth,
    gender,
    referalId,
    active,
    language,
    timeZone,
    currentUrl,
    sid,
    socialID,
    country,
    state,
    geo,
    clickid,
    ipAddress,
    sessionId,
    uid,
    isGuest,
    altcha,
    marketingConsent,
    isSubscribed,
    credential,
  });
};

export const updateGuestProfileApi = async (cred) => {
  const {
    uid,
    password,
    firstName,
    lastName,
    email,
    language,
    timeZone,
    currentUrl,
    country,
    state,
  } = cred;
  return securePost("/api/user/updateGuestUserProfile", {
    password,
    firstName,
    lastName,
    email,
    language,
    timeZone,
    currentUrl,
    country,
    state,
    uid,
  });
};

export const saveUserDetail = async (landing_url: string, ip_address: string, country: string) => {
  return secureGet("/api/user/saveUserDetails", { landing_url, ip_address, country });
};

export const GetDetailsOfVerificationUserApi = async (emailID: string, name: string) => {
  return securePost("/api/survey/getVerificationData", { emailID, name });
};

export const SendOtpApi = async (email, altcha) => {
  return securePost("/api/user/send-otp", { email, app: "zampliasurveys", altcha });
};

export const ReSendOtpApi = async (email) => {
  return securePost("/api/user/resend-otp", { email, app: "zampliasurveys" });
};

export const VerifyOtpApi = async (email, otp) => {
  return securePost("/api/user/verify-otp", { email, otp });
};

export const saveQualificationDetailApi = async (qualificationData, email, panelListId, countryName) => {
  return securePost("/api/survey/saveQualification", { ...qualificationData, email, panelListId, countryName });
};
